import { parentesco } from '@utils';
import { certidaoGenitor, childs, commons, death, others } from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constants } = parentesco;

export const ContConjulgadaFinDocs = () => {
  const rules = {
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCertidaoNascimento: dynamicRule('required'),
    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),
    anexoOutros: dynamicRule(),
  };

  const docs = {
    commons: [...commons, ...death, ...childs],
    others: [...others],
    [constants.FILHO]: [],
    [constants.ENTEADO]: [...certidaoGenitor],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
